import {IconProps} from "../../types/IconProps";

export const WarningIcon = ({ width = 800, color = '#fff'}: IconProps) => {
    return (
        <svg fill={color} width={`${width}px`} height={`${width}px`} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"
             id="warning-alt" className="icon glyph">
            <path
                d="M22.25,17.55,14.63,3.71a3,3,0,0,0-5.26,0L1.75,17.55A3,3,0,0,0,4.38,22H19.62a3,3,0,0,0,2.63-4.45ZM12,18a1,1,0,1,1,1-1A1,1,0,0,1,12,18Zm1-5a1,1,0,0,1-2,0V9a1,1,0,0,1,2,0Z"></path>
        </svg>
    )
}